"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tertiary = exports.secondary = exports.primary = void 0;
var sharedClasses = 'flex items-center justify-center text-xs md:text-base px-[15px] py-[10px] rounded uppercase w-full sm:min-w-[270px] sm:w-auto font-semibold transition-color duration-200 disabled:cursor-not-allowed disabled:opacity-30';
var primary = {
  solidClasses: "".concat(sharedClasses, " bg-brand-primary text-brand-white hover:text-brand-white hover:no-underline hover:bg-brand-primary-lighten active:bg-brand-primary-darken"),
  outlineClasses: "".concat(sharedClasses, " bg-transparent text-brand-primary border-2 border-brand-primary hover:bg-brand-primary hover:text-brand-white hover:no-underline active:bg-brand-primary-darken"),
  linkClasses: "".concat(sharedClasses, " bg-transparent text-brand-primary")
};
exports.primary = primary;
var secondary = {
  solidClasses: "".concat(sharedClasses, " bg-brand-secondary text-brand-white hover:text-brand-white hover:no-underline hover:bg-brand-secondary-lighten active:bg-brand-secondary-darken"),
  outlineClasses: "".concat(sharedClasses, " bg-transparent text-brand-primary border-2 border-brand-primary hover:bg-brand-primary hover:text-brand-white hover:no-underline active:bg-brand-primary-darken"),
  linkClasses: "".concat(sharedClasses, " bg-transparent text-brand-secondary")
};
exports.secondary = secondary;
var tertiary = {
  solidClasses: "".concat(sharedClasses, " bg-brand-black text-brand-white hover:text-brand-white hover:no-underline hover:bg-brand-black-lighten active:bg-brand-black-darken"),
  outlineClasses: "".concat(sharedClasses, " bg-transparent text-brand-black border-2 border-brand-black hover:bg-brand-black hover:text-brand-white hover:no-underline active:bg-brand-black-darken"),
  linkClasses: "".concat(sharedClasses, " bg-transparent text-brand-black")
};
exports.tertiary = tertiary;